import { ChevronDown, ChevronRight } from 'lucide-react'

export function BdrQueueGroupHeader({
  label,
  count,
  color,
  icon: Icon,
  collapsed,
  onToggle,
}: {
  label: string
  count: number
  color: string
  icon: React.ElementType
  collapsed: boolean
  onToggle: () => void
}) {
  return (
    <button
      onClick={onToggle}
      className="flex items-center gap-2.5 w-full py-2.5 px-1 text-left group min-h-[44px]"
    >
      <div className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: color }} />
      <Icon size={15} style={{ color }} className="shrink-0" />
      <span className="text-text-primary text-sm font-semibold flex-1">{label}</span>
      <span
        className="text-[11px] font-bold px-2 py-0.5 rounded-full"
        style={{ color, backgroundColor: `${color}18` }}
      >
        {count}
      </span>
      {collapsed ? (
        <ChevronRight size={14} className="text-text-muted" />
      ) : (
        <ChevronDown size={14} className="text-text-muted" />
      )}
    </button>
  )
}

export function BdrQueueEmptyGroup({ message }: { message: string }) {
  return (
    <div className="text-text-muted text-xs text-center py-4 italic opacity-60">{message}</div>
  )
}
